<script setup>
import { computed } from 'vue';
import { get } from 'lodash';
import IconButton from '@/components/shared/IconButton.vue';
import VideosGrid from './VideosGrid.vue';
import PicturesGrid from './PicturesGrid.vue';

const emit = defineEmits([
  'close',
  'item-selected',
  'gallery-picture-selected',
]);

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  mediaType: {
    type: String,
    default: 'pictures',
  },
  canClose: {
    type: Boolean,
    default: false,
  },
});

const data = computed(() => {
  return {
    items: get(this, 'activeOverlay.data.items', props.items),
    mediaType: get(this, 'activeOverlay.data.mediaType', props.mediaType),
  };
});

function close() {
  window._paq.push(['trackEvent', 'Navigation', 'CloseOverlayX']);
  emit('close');
}

function mediaSelected(index) {
  emit('item-selected', index);
}
</script>

<template>
  <div
    class="media-list"
    :class="{
      galleries: data.mediaType === 'galleries',
    }"
  >
    <IconButton
      v-if="canClose"
      :icon="['fal', 'times']"
      @click="close"
      class="mb-12"
    />

    <PicturesGrid
      v-if="data.mediaType === 'pictures'"
      :pictures="data.items.map((picture) => picture.source)"
      @picture-selected="mediaSelected"
    />

    <VideosGrid
      :videos="data.items"
      @video-selected="mediaSelected"
      v-else-if="data.mediaType === 'videos'"
    />
  </div>
</template>
